import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  ContentSection,
  InstructionStepper,
  Layout,
  Paragraph,
  SectionHeading,
} from '@vwfs-bronson/bronson-react';

interface ComponentProps {
  setSavedDocuments?: any;
}

export const ConfirmationPage: FunctionComponent<ComponentProps> = ({ setSavedDocuments }) => {
  const { t } = useTranslation();

  return (
    <>
      <ContentSection pageWrap className="u-pv-none">
        <SectionHeading level={3}>{t('step5:confiramtion:heading')}</SectionHeading>
        <Layout center>
          <Layout.Item>
            <Paragraph>{t('step5:confiramtion:descriptionSubmission')}</Paragraph>
          </Layout.Item>
          <Layout.Item>
            <Paragraph>{t('step5:confiramtion:descriptionNextSteps')}</Paragraph>
          </Layout.Item>
        </Layout>
      </ContentSection>
      <ContentSection pageWrap>
        <InstructionStepper
          statusActiveText={t('app:instructionStepper:activeLabel')}
          statusNotActiveText={t('app:instructionStepper:nonActiveLabel')}
        >
          <InstructionStepper.Step
            icon="semantic-upload"
            state="is-active"
            title={t('step5:confiramtion:instructions:upload')}
          />
          <InstructionStepper.Step
            icon="semantic-mail"
            state="is-active"
            title={t('step5:confiramtion:instructions:submit')}
          />
          <InstructionStepper.Step icon="document" title={t('step5:confiramtion:instructions:sign')} />
          <InstructionStepper.Step icon="semantic-car" title={t('step5:confiramtion:instructions:vehicle')} />
        </InstructionStepper>
      </ContentSection>
      <ContentSection>
        <Layout center>
          <Layout.Item default="1/3">
            <Button
              type="button"
              full
              secondary
              onClick={() => {
                setSavedDocuments(false);
              }}
            >
              {t('step5:navigation:return')}
            </Button>
          </Layout.Item>
        </Layout>
      </ContentSection>
    </>
  );
};
